import { notification } from 'antd'
import { getAxios } from '../axiosWithToken'
import { ERROR_MSG, SUCCESS_MSG } from '../index'
import { setUserAndToken } from '../utils'

const postSignup = (username, password) =>
  getAxios().post(`users/users/`, { username, password })

export const postLogin = (username, password) =>
  getAxios()
    .post(`auth/`, { username, password })
    .then(res => {
      if (res.status === 200) {
        setUserAndToken(res.data.username, res.data.token)
        window.location.reload()
      }
    })
    .catch(error => {
      notification.error({ message: 'Username หรือ Password ผิด' })
      return Promise.reject(error)
    })

export const postSignUpGoogle = accessToken =>
  getAxios()
    .post(`auth/google/`, { access_token: accessToken })
    .then(res => {
      if (res.status === 200) {
        setUserAndToken(res.data.username, res.data.token)
        window.location.reload()
      }
    })
    .catch(error => {
      notification.error({ message: 'เกิดข้อผิดพลาด' })
      return Promise.reject(error)
    })

export const postSignUpFacebook = accessToken =>
  getAxios()
    .post(`auth/facebook/`, { access_token: accessToken })
    .then(res => {
      if (res.status === 200) {
        setUserAndToken(res.data.username, res.data.token)
        window.location.reload()
      }
    })
    .catch(error => {
      notification.error({ message: 'เกิดข้อผิดพลาด' })
      return Promise.reject(error)
    })

export const signUpAndLogin = (username, password) =>
  postSignup(username, password)
    .then(() => {
      postLogin(username, password)
    })
    .catch(error => {
      notification.error({ message: 'เกิดข้อผิดพลาด' })
      return Promise.reject(error)
    })

export const patchAccountDetail = body =>
  getAxios()
    .patch(`me/`, body)
    .then(() => notification.success({ message: SUCCESS_MSG }))
    .catch(() => notification.error({ message: ERROR_MSG }))

export const getAccountDetail = () => getAxios().get(`me/`)

export const AuthUserWithLine = code =>
  getAxios()
    .post(`line/auth-with-user-code/`, { code })
    .then(() => {
      window.location.href = '/me'
      setTimeout(() => window.location.reload(), 200)
    })



// WEBPACK FOOTER //
// /opt/build/repo/src/api/sync/index.js